export default __webpack_public_path__ + "static/consultationBg2-2de955686f90c4a6ec5f6556cc6425ac.png";